import Vue from "vue";

function renderSum(el, value)
{
    el.innerHTML = Vue.filter("currency").apply(Object, [value]);
}

Vue.directive("basket-item-sum",
    {
        bind(el, binding)
        {
            renderSum(el, binding.value);
        },

        update(el, binding)
        {
            renderSum(el, binding.value);
        }
    });
